import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const ClientRenewalsLayout = () => {
  const navList = useNav();
  let { clientRenewalsBottomHeader, clientRenewalsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={clientRenewalsBottomHeader} topTabs={clientRenewalsTopHeader} />
      <Outlet />
    </div>
  );
};

export default ClientRenewalsLayout;
